// Components
import { PlainDropdown } from "../dropdown/Dropdown";

// Target Group Selection Card
export default function TargetGroupSelectionCard({
  targetGroupData = {},
  tgList = [],
  tgId,
  setTgId,
  campaignId,
}) {
  const { step, title, message } = targetGroupData || {};

  return (
    <div className="card shadow mb-4 mt-3">
      <div className="d-flex justify-content-between">
        <div className="card-content">
          <p className="card__step">{step}</p>
          <p className="card__title">{title}</p>
          <p className="card__message">{message}</p>
        </div>
        <div className="card-action">
          <PlainDropdown
            items={tgList}
            className="btn shadow-none rounded-lg border border-primary mt-4 btn-action px-3"
            placeHolder="Select Target Group"
            onItemSelect={setTgId}
            dropMenuClassName="dropdown-fixed-height"
            selectedId={tgId} // existing tg for campaign
            disabled={campaignId} // disable for uploading in existing campaign
            isFirstItemSelectable={true}
          />

          {/* if uploading excel to existing campaign then froze the tg selection */}
          {campaignId && (
            <p className="text-primary my-2 font-weight-bold text-center">
              TARGET GROUP FROZEN
            </p>
          )}
        </div>
      </div>
    </div>
  );
}
